class CustomerDropdownController {
  constructor($scope, $rootScope, $http, $timeout, $element) {
    "ngInject";
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$element = $element;
    
    this.searchText = '';
    this.isOpen = false;
    this.customers = [];
    this.filteredCustomers = [];
    this.loading = false;
    this.page = 0;
    this.pageSize = 20;
    this.hasMore = true;
    this.allCustomersLoaded = false;
    this.mouseInDropdown = false;
    
    // Initialize search text if customer is pre-selected
    if (this.selectedCustomer) {
      this.searchText = this.selectedCustomer.name || '';
    }
    
    // Load initial customers
    this.loadCustomers();
    
    // Watch for changes to selectedCustomer from outside
    $scope.$watch(() => this.selectedCustomer, (newVal) => {
      if (newVal && newVal.name) {
        this.searchText = newVal.name;
      } else if (!newVal) {
        this.searchText = '';
      }
    });
    
    // Setup scroll listener after view init
    $scope.$on('$destroy', () => {
      if (this.scrollElement) {
        this.scrollElement.removeEventListener('scroll', this.scrollHandler);
      }
    });
  }
  
  
  loadCustomers(reset = false) {
    if (this.loading) return;
    
    this.loading = true;
    
    if (reset) {
      this.page = 0;
      this.customers = [];
      this.hasMore = true;
    }
    
    let url = this.$rootScope.apiHost + "/api/admin/customers";
    
    this.$http.get(url, { withCredentials: true })
      .then((response) => {
        let customersData = response.data || [];
        
        // Sort customers alphabetically by name
        customersData.sort((a, b) => {
          const nameA = (a.name || '').toLowerCase();
          const nameB = (b.name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        
        if (reset) {
          this.customers = customersData;
        } else {
          this.customers = [...this.customers, ...customersData];
          // Re-sort the combined array
          this.customers.sort((a, b) => {
            const nameA = (a.name || '').toLowerCase();
            const nameB = (b.name || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
        }
        
        this.allCustomersLoaded = true;
        this.filterCustomers();
        this.loading = false;
      })
      .catch((error) => {
        console.error('Error loading customers:', error);
        this.loading = false;
      });
  }
  
  filterCustomers() {
    if (!this.searchText || this.searchText.trim() === '') {
      this.filteredCustomers = this.customers.slice(0, this.pageSize);
      this.hasMore = this.customers.length > this.pageSize;
    } else {
      const searchLower = this.searchText.toLowerCase();
      this.filteredCustomers = this.customers.filter(customer => 
        customer.name && customer.name.toLowerCase().includes(searchLower)
      ).slice(0, this.pageSize);
      this.hasMore = false; // Don't show "load more" when filtering
    }
  }
  
  onSearchChange() {
    this.filterCustomers();
  }
  
  onInputFocus() {
    this.isOpen = true;
    this.filterCustomers();
    this.setupScrollHandler();
  }
  
  setupScrollHandler() {
    // Setup scroll handler when dropdown opens
    this.$timeout(() => {
      const element = this.$element[0].querySelector('.customer-dropdown-list');
      if (element && !this.scrollElement) {
        this.scrollElement = element;
        this.scrollHandler = (event) => {
          this.onScroll(event);
          this.$scope.$apply();
        };
        element.addEventListener('scroll', this.scrollHandler);
      }
    }, 50);
  }
  
  onInputBlur() {
    // Delay closing to allow click events to fire
    this.$timeout(() => {
      if (!this.mouseInDropdown) {
        this.isOpen = false;
      }
    }, 200);
  }
  
  onDropdownMouseEnter() {
    this.mouseInDropdown = true;
  }
  
  onDropdownMouseLeave() {
    this.mouseInDropdown = false;
    this.isOpen = false;
  }
  
  selectCustomer(customer) {
    this.selectedCustomer = customer;
    this.searchText = customer.name;
    this.isOpen = false;
    
    if (this.onSelect) {
      this.onSelect({ customer: customer });
    }
  }
  
  clearSelection() {
    this.selectedCustomer = null;
    this.searchText = '';
    this.isOpen = false;
    
    if (this.onSelect) {
      this.onSelect({ customer: null });
    }
  }
  
  onScroll(event) {
    const element = event.target;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    
    // Load more when scrolled to within 50px of bottom
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      this.loadMore();
    }
  }
  
  loadMore() {
    if (this.loading || !this.hasMore || (this.searchText && this.searchText.trim() !== '')) return;
    
    this.page++;
    const startIndex = this.page * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    
    const remainingCustomers = this.customers.slice(startIndex, endIndex);
    if (remainingCustomers.length > 0) {
      this.filteredCustomers = [...this.filteredCustomers, ...remainingCustomers];
      this.hasMore = endIndex < this.customers.length;
    } else {
      this.hasMore = false;
    }
  }
  
  isSelected(customer) {
    return this.selectedCustomer && this.selectedCustomer.id === customer.id;
  }
}

export default CustomerDropdownController;




// WEBPACK FOOTER //
// ./client/common/directives/customer-dropdown/customer-dropdown.controller.js